// engine
import { StateController, autoplay, delay, dispatcher, platform, serverData } from "@aceroll/core";
import { POPUP_AUTO_PROCEED_TIME } from "../constants";

// services
import { sounds } from '../services';

class FeatureExitController extends StateController {
    constructor() {
        super("feature.exit");
        this.app = dispatcher.app;
    }

    async onStart() {
        const totalWinPopup = this.app.layout.totalWinPopup;
        const totalWinAmount = serverData.currentResponse.totalWinAmount;
        // don't need to hide. it will be hiden in next state
        // this.app.layout.multiplierPanel.hide();

        totalWinPopup.show(totalWinAmount);
        platform.setFeatureExit();


        if (!autoplay.isStarted() || autoplay.isStopNeededOnFeature()) {
            await platform.onceClickScreen();
        } else {
            await Promise.race([
                delay(POPUP_AUTO_PROCEED_TIME),
                platform.onceClickScreen()
            ]);
        }

        sounds.fadeOutCurrentAmbient(1000);
        this.app.layout.setMainGameLayout();
        await totalWinPopup.hide();
        serverData.setCurrentResponse();
        this.stop();
    }

    onStop() {
        sounds.setBaseAmbient(1000);
        serverData.currentFeature = null;
    }
}

export default FeatureExitController;